import BaseRequest from '../_baseRequest';

const baseUrl = 'Report/ReportByUrl';

const RicercaCodiceSvc = {
  getList: () => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: 'ricercacodice_criterio?haRuolo' },
      null,
      'post',
      `/api/${baseUrl}`,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  getValueList: (tipoUnit) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `ricercacodice_criterio_lov?haRuolo&ptipounit=${tipoUnit}` },
      null,
      'post',
      `/api/${baseUrl}`,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  getDetail: (tipoUnit, prc) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `ricercacodice_criterio_res?haRuolo&ptipounit=${tipoUnit}&prc=${prc}` },
      null,
      'post',
      `/api/${baseUrl}`,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  }
};
export default RicercaCodiceSvc;
